import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import deliverooImage from "../images/deliveroo.png";
import justEatImage from "../images/justEat.png";

const extLinkProps = {
  target: "_blank",
  rel: "noopener noreferrer",
  referrerPolicy: "no-referrer" as const, // optional but nice
};

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-white py-4 mt-5">
      <Container>
        <Row className="text-center text-md-start">
          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="fw-bold">Bartollini Pizza</h5>
            <p className="mb-1">Ballybrit, Galway, H91 WC5P</p>
            <p className="mb-0">Ireland</p>
          </Col>

          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="fw-bold">Follow Us</h5>
            <div className="social-link d-flex justify-content-center justify-content-md-start gap-3 mt-2">
              <a
                href="https://www.instagram.com/bartollinipizza/"
                className="text-white"
                aria-label="Instagram"
                {...extLinkProps}
              >
                <FontAwesomeIcon icon={faInstagram} size="2xl" />
              </a>

              <a
                href="https://www.facebook.com/p/Bartollini-Pizza-100088858897153/"
                className="text-white"
                aria-label="Facebook"
                {...extLinkProps}
              >
                <FontAwesomeIcon icon={faFacebook} size="2xl" />
              </a>

              <a
                href="https://www.tiktok.com/@bartollinipizza?_t=ZN-8yb5VuvGUUA&_r=1"
                className="text-white"
                aria-label="TikTok"
                {...extLinkProps}
              >
                <FontAwesomeIcon icon={faTiktok} size="2xl" />
              </a>
            </div>
          </Col>

          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="fw-bold">Order For Delivery</h5>
            <div className="delivery-link d-flex justify-content-center justify-content-md-start gap-3 mt-2">
              <a
                href="https://www.just-eat.ie/restaurants-bartollini-pizza-limited-galway/menu"
                className="text-white"
                aria-label="Just Eat"
                {...extLinkProps}
              >
                <img
                  src={justEatImage}
                  alt="Just Eat"
                  loading="lazy"
                  style={{ marginTop: "-6px", height: "4em", width: "auto" }}
                />
              </a>

              <a
                href="https://deliveroo.ie/menu/galway/briarhill-business-park/bartollini-pizza"
                className="text-white"
                aria-label="Deliveroo"
                {...extLinkProps}
              >
                <img
                  src={deliverooImage}
                  alt="Deliveroo"
                  loading="lazy"
                  style={{ height: "3em", width: "auto" }}
                />
              </a>
            </div>
          </Col>

          <Col md={3}>
            <h5 className="fw-bold">Contact</h5>
            <p className="mb-1">
              <a href="mailto:bartollinipizza@gmail.com" className="footer-link">
                bartollinipizza@gmail.com
              </a>
            </p>
            <p className="mb-0">
              <a href="tel:+353892063068" className="footer-link">
                089 206 3068
              </a>
            </p>
          </Col>
        </Row>

        <hr className="border-light mt-4" />
        <p className="text-center mb-0 small">
          &copy; {new Date().getFullYear()} Bartollini Pizza. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
